import { calculateDifference } from '@app/utils/filter/terms/calculate-difference';
import { Value } from '@app/utils/filter/terms/value';

export type GreaterThan = {
  arguments: [Value];
  key: string;
  operator: 'gt';
};

export const greaterThan = function (value: any, lowerBound: Value): boolean {
  return calculateDifference(value, lowerBound) < 0;
};
